module.exports = __webpack_public_path__ + "img/filter.c8a32878.svg";